import { createSlice } from "@reduxjs/toolkit";

export const ownerSlice = createSlice({
  name: 'owner',
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startLog: (state) => { state.isLoading = true; },
    setLogin: (state, { payload: { data, error }}) => { 
      state.data = data ?? null;
      state.error = error ?? null;
      state.isLoading = false;
    }
  }
});

export const { startLog, setLogin } = ownerSlice.actions;
